module.exports = __webpack_public_path__ + "media/images/img_service_merit_4-a19b319fbc875f8a1806844fd89af053.png";